import { bn, bnOrZero } from '@shapeshiftoss/utils';
export const microLamportsToLamports = (microLamports) => {
    return bnOrZero(microLamports).div(bn(10).pow(6)).toFixed();
};
